// extracted by mini-css-extract-plugin
module.exports = {"col":"col_col__1Zst3","full":"col_full__388Zr"};